// "Minha conta" (Parte 3.8; REQ-AUTH-029 sessões com step-up, troca de senha `POST /me/password`): SelfScope, chaves `['me', …]`.
import type { components } from '@giyus/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useApiClient } from '../../../lib/api/apiClientContext';

export type MySession = components['schemas']['IdentitySessionResponse'];

export const MY_SESSIONS_KEY = ['me', 'sessions'] as const;

export function useMySessions() {
  const client = useApiClient();
  return useQuery({
    queryKey: MY_SESSIONS_KEY,
    queryFn: async (): Promise<MySession[]> => {
      const { data } = await client.GET('/api/v1/me/sessions');
      return data ?? [];
    },
    meta: { silent: true },
  });
}

/** `DELETE /me/sessions/{id}` exige step-up: o chamador envolve com `useStepUpAction`. */
export function useRevokeMySession() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (sessionId: string): Promise<void> => {
      await client.DELETE('/api/v1/me/sessions/{sessionId}', { params: { path: { sessionId } } });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: MY_SESSIONS_KEY });
    },
    meta: { silent: true },
  });
}

export interface ChangePasswordInput {
  readonly currentPassword: string;
  readonly newPassword: string;
}

/** `POST /me/password` (Bearer + step-up): senha atual conferida, política e histórico no servidor (REQ-AUTH-003). */
export function useChangePassword() {
  const client = useApiClient();
  return useMutation({
    mutationFn: async (input: ChangePasswordInput): Promise<void> => {
      await client.POST('/api/v1/me/password', { body: input });
    },
    meta: { silent: true },
  });
}
